export const TESTID = {
  // Login
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginMagicLinkToggle: "login-magic-link-toggle",
  loginPasswordToggle: "login-password-toggle",
  loginMagicSubmit: "login-magic-submit",
  loginMagicEmail: "login-magic-email-input",
  loginForgotLink: "login-forgot-password-link",
  loginError: "login-error-message",
  loginSuccessBanner: "login-success-banner",

  // MFA
  mfaCodeInput: "mfa-code-input",
  mfaSubmit: "mfa-submit-button",
  mfaError: "mfa-error-message",

  // Magic link verify
  magicVerifyStatus: "magic-verify-status",

  // Password reset
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-button",
  resetPassword: "reset-password-input",
  resetSubmit: "reset-submit-button",

  // Dashboard / nav
  navLogo: "nav-logo",
  navLogout: "nav-logout-button",
  navProfile: "nav-profile-link",
  navDashboard: "nav-dashboard-link",
  navRoster: "nav-roster-link",
  navSignals: "nav-signals-link",

  // Dashboard
  statTotal: "stat-total-users",
  statActive: "stat-active-users",
  statMfa: "stat-mfa-users",
  statLogins24: "stat-logins-24h",

  // Roster
  rosterTable: "roster-table",
  rosterSearch: "roster-search-input",
  rosterRow: "roster-row",
  rosterAddBtn: "roster-add-button",
  rosterRoleFilter: "roster-role-filter",

  // Add/Edit user modal
  userEmail: "user-form-email",
  userName: "user-form-name",
  userPassword: "user-form-password",
  userCallsign: "user-form-callsign",
  userRank: "user-form-rank",
  userTier: "user-form-tier",
  userRole: "user-form-role",
  userHullsCheckbox: "user-form-hulls-checkbox",
  userSubmit: "user-form-submit",
  userEdit: "user-row-edit",
  userDelete: "user-row-delete",
  userForceReset: "user-row-force-reset",
  userSendMagic: "user-row-send-magic",
  userDisableMfa: "user-row-disable-mfa",

  // Profile
  profileMfaToggle: "profile-mfa-toggle",
  profileMfaQr: "profile-mfa-qr",
  profileMfaCode: "profile-mfa-code-input",
  profileMfaEnable: "profile-mfa-enable",
  profileMfaDisable: "profile-mfa-disable",
  profileBackupCodes: "profile-backup-codes",
  profileChangePwCurrent: "profile-change-pw-current",
  profileChangePwNew: "profile-change-pw-new",
  profileChangePwSubmit: "profile-change-pw-submit",

  // Signals
  signalsTable: "signals-table",
  signalsRow: "signals-row",
};
